<template>
  <div id="support_input">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'arrow_flow2'"
          />
          <section>
            <h1>フォームでのお問い合わせ</h1>
            <ul class="ul_input_support">
              <li>
                <div>
                  <span class="important small_text">必須</span>
                  <span>{{label.supportType}}</span>
                </div>
                <select v-model="support.supportType">
                  <!-- <option hidden>選択ください</option> -->
                  <option v-for="(support,index) in supportTypeList" :key="'support-' + index" v-bind:value="support">{{support.label}}</option>
                </select>
                <div v-if="errors.supportType" class="error_text">{{errors.supportType}}</div>
              </li>
              <li>
                <div>
                  <span>{{label.supportMaker}}</span>
                </div>
                <select v-model="support.supportMaker">
                  <!-- <option hidden>選択ください</option> -->
                  <option v-for="(support,index) in supportMakerList" :key="'support-maker-' + index" :value="support">{{support.label}}</option>
                </select>
                <div v-if="errors.supportMaker" class="error_text">{{errors.supportMaker}}</div>
              </li>
              <li>
                <div>
                  <span class="important small_text">必須</span>
                  <span>{{label.supportTitle}}</span>
                </div>
                <input type="text" v-model.trim="support.supportTitle" maxlength="128" placeholder="件名"/>
                <div v-if="errors.supportTitle" class="error_text">{{errors.supportTitle}}</div>
              </li>
              <li>
                <div>
                  <span class="important small_text">必須</span>
                  <span>{{label.supportBody}}</span>
                </div>
                <textarea v-model="support.supportBody" cols="100" rows="5" maxlength="256"/>
                <div v-if="errors.supportBody" class="error_text">{{errors.supportBody}}</div>
              </li>
              <li>
                <div>
                  <span class="important small_text">必須</span>
                  <span>{{label.userName}}</span>
                </div>
                <div>
                  <input type="text" v-model.trim="support.userLastName" placeholder="家具" maxlength="32"/>
                  <input type="text" v-model.trim="support.userFirstName" placeholder="太郎" maxlength="32"/>
                </div>
                <div v-if="errors.userName" class="error_text">{{errors.userName}}</div>
              </li>
              <li>
                <div>
                  <span class="important small_text">必須</span>
                  <span>{{label.userNameKana}}</span>
                </div>
                <div>
                  <input type="text" v-model.trim="support.userLastNameKana" placeholder="カグ" maxlength="32"/>
                  <input type="text" v-model.trim="support.userFirstNameKana" placeholder="タロウ" maxlength="32"/>
                </div>
                <div v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</div>
              </li>
              <li>
                <div>
                  <span class="important small_text">必須</span>
                  <span>{{label.email}}</span>
                </div>
                <input type="text" v-model.trim="support.email" maxlength="128" placeholder="****@domans.co.jp"/>
                <div v-if="errors.email" class="error_text">{{errors.email}}</div>
              </li>
              <li>
                <div>
                  <span>{{label.tel}}</span>
                </div>
                <input type="text" v-model.trim="support.tel" @keypress="validateNumber" @input="support.tel=inputRestNumber($event)" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="0123456789" maxlength="11"/>
                <div v-if="errors.tel" class="error_text">{{errors.tel}}</div>
              </li>
            </ul>
            <div class="detail_btn2 btn_pos_center" @click="cofirm()">確認画面へ 〉〉</div>
            <!-- <div class="control_btn_area">
              <div class="main_btn sel_sub_btn" @click="cancel()">
                <a>戻る</a>
              </div>
              <div class="main_btn sel_main_btn" @click="cofirm()">
                <a>お問合せする</a>
              </div>
            </div> -->
          </section>
          <section>
            <h2>お電話でのお問い合わせ</h2>
            <p>mm/styleは、ご質問の内容によってお問い合わせ先が異なります。</p>
            <h3>mm/styleの操作・支払い・その他サービス全般について</h3>
            <p class="indent_p">商品金額の確認方法やお支払いについて、また問い合わせ先に迷われるような場合、以下電話番号へご連絡ください。</p>
            <dev v-if="!isHaseko">
              <a href="tel:0362761123"><img :src="getImage('bunner/TEL.webp')"></a>
            </dev>
            <h3>商品・配送・ご注文内容の確認について</h3>
            <p class="indent_p">商品の仕様やお届け可能日、ご注文いただいた商品については、mm/styleに商品を掲載している各メーカーへのお問い合わせとなります。メーカー名は、各商品の詳細ページに記載されております。</p>
            <table>
              <tbody>
                <tr>
                  <td>メーカー</td>
                  <td>連絡先</td>
                  <td>受付時間</td>
                </tr>
                <tr>
                  <td>ファニチャーメーカー株式会社</td>
                  <td><a href="tel:0363009085">03-6300-9085</a></td>
                  <td>月〜金曜 10:00〜18:00 (定休：土日祝)</td>
                </tr>
                <tr>
                  <td>株式会社みうら</td>
                  <td><a href="tel:0834645511">0834-64-5511</a></td>
                  <td>月〜金曜 10:00〜18:00 (定休：土日祝)</td>
                </tr>
                <tr>
                  <td>アクシス株式会社</td>
                  <td><a href="tel:0665362030">06-6536-2030</a></td>
                  <td>月〜金曜 9:00〜18:00 (定休：土日祝)</td>
                </tr>
                <tr>
                  <td>株式会社テクマ</td>
                  <td><a href="tel:0795525498">079-552-5498</a></td>
                  <td>月〜金曜 9:00〜18:00 (定休：土日祝)</td>
                </tr>
                <tr>
                  <td>ドゥーマンズ株式会社</td>
                  <td><a href="tel:0362768010">03-6276-8010</a></td>
                  <td>月〜金曜 9:00〜18:00 (定休：土日祝)</td>
                </tr>
              </tbody>
            </table>
            <h3>組立設置について</h3>
            <p class="indent_p">組立設置サービスについては、キャンディルテクトへのお問い合わせとなります。</p>
            <table>
              <tbody>
                <tr>
                  <td>株式会社キャンディルテクト</td>
                  <td><a href="tel:0356253095">03-5625-3095</a></td>
                  <td>10:00〜18:00 (定休無し)</td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import * as App from '../../utils/App'
import * as FormUtil from '../../utils/FormUtil'
import * as Check from '../../utils/Check'
import {DC_STORAGE_KEY, STRUCT_CORP_ID_ST, STRUCT_CORP_ID_ED} from '../../constants/App'
// Module
import DcHeader from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcSiteMap from '../components/common/DcSiteMap'
import {SUPPORT_MAKER, SUPPORT_TYPE} from '../constants/TypeEc'

export default {
  name: 'SupportInput',
  components: {
    'dd-header': DcHeader,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'supportInput',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'supportInput', key: 'supportInput', title: 'お問い合わせ入力'},
        {id: 'supportConfirm', key: 'supportConfirm', title: 'お問い合わせ内容確認'},
        {id: 'supportComplete', key: 'supportComplete', title: 'お問い合わせ完了'}
      ],
      support: {
        supportType: {},
        supportMaker: {},
        supportTitle: '',
        supportBody: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        email: '',
        tel: ''
      },
      errors: {},
      label: {
        supportType: '質問カテゴリ',
        supportMaker: 'お問い合わせメーカー',
        supportTitle: '件名',
        supportBody: '本文',
        userName: 'ご氏名',
        userNameKana: 'ご氏名（カナ）',
        email: 'ご連絡先メールアドレス',
        tel: 'お電話番号'
      },
      user: {}
    }
  },
  computed: {
    supportTypeList: function () {
      return Object.keys(SUPPORT_TYPE)
        .map(e => SUPPORT_TYPE[e])
    },
    supportMakerList: function () {
      return Object.keys(SUPPORT_MAKER)
        .map(e => SUPPORT_MAKER[e])
    },
    isHaseko: function () {
      return (this.user && this.user.corpId >= STRUCT_CORP_ID_ST && this.user.corpId <= STRUCT_CORP_ID_ED)
    }

  },
  methods: {
    cofirm: function () {
      // エラーメッセージのクリア
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        return
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        return
      }

      App.setLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA, this.support)

      this.$router.push({
        name: 'SupportConfirm',
        params: {
          supportData: this.support
        }
      })
    },
    cancel: function () {
      this.$router.go(-1)
    },
    validateRequire: function () {
      if (!this.support.supportType) this.errors['supportType'] = this.label.supportType + 'は必須項目です。'
      if (!this.support.supportTitle) this.errors['supportTitle'] = this.label.supportTitle + 'は必須項目です。'
      if (!this.support.supportBody) this.errors['supportBody'] = this.label.supportBody + 'は必須項目です。'
      if (!this.support.userLastName || !this.support.userFirstName) this.errors['userName'] = this.label.userName + 'は必須項目です。'
      if (!this.support.userLastNameKana || !this.support.userFirstNameKana) this.errors['userNameKana'] = this.label.userNameKana + 'は必須項目です。'
    },
    validateFormat: function () {
      if (!Check.isKana(this.support.userLastNameKana) || !Check.isKana(this.support.userFirstNameKana)) {
        this.errors['userNameKana'] = this.label.userNameKana + 'はカタカナで入力してください。'
      }
      if (!Check.isTel(this.support.tel)) this.errors['tel'] = '電話番号は半角数値かつ、10～11文字で入力してください。'
      if (!Check.isMail(this.support.email)) this.errors['email'] = 'メールアドレスの形式ではありません。'
    },
    fetchData: function () {
      let lform = App.getLocalStorage(DC_STORAGE_KEY.SUPPORT_DATA)
      if (lform) {
        this.support = lform
      }
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    }
  },
  created () {
    this.fetchData()
    let makerId = this.$route.query.maker
    if (makerId) {
      let supportMaker = this.supportMakerList.find(e => e.code === Number(makerId))
      this.$set(this.support, 'supportMaker', supportMaker)
    }
    this.user = App.getLocalStorage(DC_STORAGE_KEY.USER_INFO)
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcSupportInput.vue